export enum EmailPreferenceLevelType {
    User = 0,
    Protocol = 2,
    Site = 3,
}